import { VendorFormType, VendorFormQuestionType } from './Enums';
import { VendorModel } from './VendorModel';


export class VendorFormModel {

    public constructor(init?: Partial<Pick<VendorFormModel, keyof VendorFormModel>>) {

        if (init) {
            if (typeof init.createdAt === 'string') {
                init.createdAt = new Date(init.createdAt);
            }
            if (typeof init.updatedAt === 'string') {
                init.updatedAt = new Date(init.updatedAt);
            }
            if (typeof init.deletedAt === 'string') {
                init.deletedAt = new Date(init.deletedAt);
            }
            if (init.questions && init.questions.length) {
                init.questions = init.questions.map((item: any) => new VendorFormQuestionModel(item));
            }
            if (init.vendor) {
                init.vendor = new VendorModel(init.vendor);
            }
            Object.assign(this, init);
        }
    }

    id: number;
    vendorId: number;
    vendor?: VendorModel;
    title: string;
    description: string;
    terms: string; // Términos y condiciones (opcional, puede venir null/vacío)
    imageUrl: string;
    type: VendorFormType;
    completionLimit: number;
    isActive: boolean;
    ordinal: number;
    createdAt: Date;
    updatedAt?: Date;
    deletedAt?: Date;
    questions: VendorFormQuestionModel[] = [];
}


export class VendorFormEditModel {

    public constructor(init?: Partial<Pick<VendorFormEditModel, keyof VendorFormEditModel>>) {

        if (init) {
            if (init.questions && init.questions.length) {
                init.questions = init.questions.map((item: any) => new VendorFormQuestionEditModel(item));
            }
            Object.assign(this, init);
        }
    }

    id = 0;
    vendorId: number;
    title: string;
    description: string;
    type: VendorFormType;
    completionLimit: number;
    isActive: boolean;
    ordinal: number;
    questions: VendorFormQuestionEditModel[] = [];
}


export class VendorFormQuestionModel {

    public constructor(init?: Partial<Pick<VendorFormQuestionModel, keyof VendorFormQuestionModel>>) {

        if (init) {
            if (typeof init.createdAt === 'string') {
                init.createdAt = new Date(init.createdAt);
            }
            if (typeof init.updatedAt === 'string') {
                init.updatedAt = new Date(init.updatedAt);
            }
            if (typeof init.deletedAt === 'string') {
                init.deletedAt = new Date(init.deletedAt);
            }
            if (init.options && init.options.length) {
                init.options = init.options.map((item: any) => new VendorFormQuestionOptionModel(item));
            }
            Object.assign(this, init);
        }
    }

    id: number;
    vendorFormId: number;
    question: string;
    type: VendorFormQuestionType;
    ordinal: number;
    createdAt: Date;
    updatedAt?: Date;
    deletedAt?: Date;
    options: VendorFormQuestionOptionModel[] = [];
}


export class VendorFormQuestionEditModel {

    public constructor(init?: Partial<Pick<VendorFormQuestionEditModel, keyof VendorFormQuestionEditModel>>) {

        if (init) {
            if (init.options && init.options.length) {
                init.options = init.options.map((item: any) => new VendorFormQuestionOptionEditModel(item));
            }
            Object.assign(this, init);
        }
    }

    id = 0;
    vendorFormId: number;
    question: string;
    type: VendorFormQuestionType;
    ordinal: number;
    options: VendorFormQuestionOptionEditModel[] = [];
}


export class VendorFormQuestionOptionModel {

    public constructor(init?: Partial<Pick<VendorFormQuestionOptionModel, keyof VendorFormQuestionOptionModel>>) {

        if (init) {
            if (typeof init.createdAt === 'string') {
                init.createdAt = new Date(init.createdAt);
            }
            if (typeof init.updatedAt === 'string') {
                init.updatedAt = new Date(init.updatedAt);
            }
            if (typeof init.deletedAt === 'string') {
                init.deletedAt = new Date(init.deletedAt);
            }
            Object.assign(this, init);
        }
    }

    id: number;
    vendorFormQuestionId: number;
    option: string;
    ordinal: number;
    createdAt: Date;
    updatedAt?: Date;
    deletedAt?: Date;
}


export class VendorFormQuestionOptionEditModel {

    public constructor(init?: Partial<Pick<VendorFormQuestionOptionEditModel, keyof VendorFormQuestionOptionEditModel>>) {

        if (init) {
            Object.assign(this, init);
        }
    }

    id = 0;
    vendorFormQuestionId: number;
    option: string;
    ordinal: number;
}


export class VendorFormSubmissionAnswerModel {

    public constructor(init?: Partial<Pick<VendorFormSubmissionAnswerModel, keyof VendorFormSubmissionAnswerModel>>) {

        if (init) {
            Object.assign(this, init);
        }
    }

    questionId: number;
    question: string;
    questionType: VendorFormQuestionType;
    optionId?: number;
    option?: string;
    answer?: string;
}


export class VendorFormCustomerSubmissionModel {

    public constructor(init?: Partial<Pick<VendorFormCustomerSubmissionModel, keyof VendorFormCustomerSubmissionModel>>) {

        if (init) {
            if (typeof init.submittedAt === 'string') {
                init.submittedAt = new Date(init.submittedAt);
            }
            if (init.answers && init.answers.length) {
                init.answers = init.answers.map((item: any) => new VendorFormSubmissionAnswerModel(item));
            }
            Object.assign(this, init);
        }
    }

    customerId: number;
    customerName: string;
    customerEmail: string;
    submissionNumber: number;
    submittedAt: Date;
    answers: VendorFormSubmissionAnswerModel[] = [];
}


export class VendorFormSubmissionModel {

    public constructor(init?: Partial<Pick<VendorFormSubmissionModel, keyof VendorFormSubmissionModel>>) {

        if (init) {
            if (typeof init.createdAt === 'string') {
                init.createdAt = new Date(init.createdAt);
            }
            Object.assign(this, init);
        }
    }

    id: number;
    vendorFormId: number;
    customerId: number;
    submissionNumber: number;
    uniqueCode: string;
    createdAt: Date;
}


export class VendorFormSubmissionsModel {

    public constructor(init?: Partial<Pick<VendorFormSubmissionsModel, keyof VendorFormSubmissionsModel>>) {

        if (init) {
            if (init.form) {
                init.form = new VendorFormModel(init.form);
            }
            if (init.submissions && init.submissions.length) {
                init.submissions = init.submissions.map((item: any) => new VendorFormCustomerSubmissionModel(item));
            }
            Object.assign(this, init);
        }
    }

    form: VendorFormModel;
    submissions: VendorFormCustomerSubmissionModel[] = [];
}


export class CreateVendorFormAnswerDto {

    public constructor(init?: Partial<Pick<CreateVendorFormAnswerDto, keyof CreateVendorFormAnswerDto>>) {

        if (init) {
            Object.assign(this, init);
        }
    }

    vendorFormQuestionId: number;
    vendorFormQuestionOptionId: number | null;
    answer: string | null;
}


export interface VendorFormCanCompleteDto {
    canComplete: boolean;
    attemptsUsed: number;
    completionLimit: number;   // 0 = ilimitado
    attemptsRemaining: number; // -1 = ilimitado
}


export class VendorFormSubmitDto {

    public constructor(init?: Partial<Pick<VendorFormSubmitDto, keyof VendorFormSubmitDto>>) {

        if (init) {
            if (init.answers && init.answers.length) {
                init.answers = init.answers.map((item: any) => new CreateVendorFormAnswerDto(item));
            }
            Object.assign(this, init);
        }
    }

    formId: number;
    customerId: number;
    uniqueCode?: string | null;
    answers: CreateVendorFormAnswerDto[] = [];
}
